import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=52817ed5"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=52817ed5&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52817ed5')) {
      api.createRecord('52817ed5', component.options)
    } else {
      api.reload('52817ed5', component.options)
    }
    module.hot.accept("./UploadFile.vue?vue&type=template&id=52817ed5", function () {
      api.rerender('52817ed5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/order/UploadFile.vue"
export default component.exports